var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('FormulateInput',{attrs:{"type":"text","label":_vm.label,"validation":_vm.validation,"input-class":_vm.disabled ? 'disabled' : 'editMode',"disabled":_vm.disabled,"validation-messages":{
    required: 'Veld is verplicht',
    min: function (ref) {
      var args = ref.args;

      return ("Waarde moet hoger zijn dan " + args);
},
    max: function (ref) {
      var args = ref.args;

      return ("Waarde moet lager zijn dan " + args);
}
  }},model:{value:(_vm.input_value),callback:function ($$v) {_vm.input_value=$$v},expression:"input_value"}})}
var staticRenderFns = []

export { render, staticRenderFns }